import TomSelect from 'tom-select';

import closeIcon from '../icons/close.svg';
import locationIcon from '../icons/location.svg';
import locationIconMini from '../icons/location-icon-mini.svg';

const GOOGLE_PLACES_API_KEY = 'AIzaSyAu-_TZATk2p5BT2B1HxTJMO9jGAUGdZMw';

type PlaceOption = {
  id: string;
  text: string;
};

type DebouncedFunction<T extends (...args: A) => void, A extends unknown[] = Parameters<T>> = (
  ...args: A
) => void;

const debounce = <T extends (...args: A) => void, A extends unknown[] = Parameters<T>>(
  fn: T,
  delay: number
): DebouncedFunction<T, A> => {
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: A) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
};

interface PlacePredictionResponse {
  suggestions: {
    placePrediction: {
      text: {
        text: string;
      };
    };
  }[];
}

const initLocationPicker = () => {
  const select = new TomSelect('[data-el="description"]', {
    valueField: 'id',
    labelField: 'text',
    searchField: ['text'],
    maxItems: 1,
    create: false,
    closeAfterSelect: true,
    persist: true,
    hideSelected: true,
    plugins: {
      clear_button: {
        title: 'Remove all selected options',
        html: function (datas: { className: string; title: string }) {
          return `<button type="button" class="${datas.className}" title="${datas.title}">${closeIcon}</button>`;
        },
      },
      restore_on_backspace: {},
    },
    openOnFocus: false,

    load: debounce(
      (query: string, callback: (options?: { id: string; text: string }[]) => void) => {
        if (!query.length) return callback();

        fetch(`https://places.googleapis.com/v1/places:autocomplete?key=${GOOGLE_PLACES_API_KEY}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': GOOGLE_PLACES_API_KEY,
            'X-Goog-FieldMask': 'suggestions.placePrediction.text.text',
          },
          body: JSON.stringify({ input: query }),
        })
          .then((res) => res.json())
          .then((json: PlacePredictionResponse) => {
            const options: PlaceOption[] = (json.suggestions || []).map((place) => ({
              id: place.placePrediction.text.text,
              text: place.placePrediction.text.text || 'Unknown place',
            }));
            callback(options);
          })
          .catch((err) => {
            console.error('Places API error:', err);
            callback();
          });
      },
      300
    ),

    render: {
      option: (data: { text: string }, escape: (str: string) => string) => `
      <div class="event_options">
        ${locationIcon}
        <span>${escape(data.text)}</span>
      </div>`,
      item: (data: { text: string }, escape: (str: string) => string) => `
      <div class="event_options event_item">
        ${locationIconMini}
        <span>${escape(data.text)}</span>
      </div>`,
      no_results: () => `
      <div class="no-results">
        No results found.
      </div>`,
    },
  });

  // Use `as HTMLInputElement` for control_input to access `value`
  select.on('clear', () => {
    const input = select.control_input as HTMLInputElement;
    input.value = '';
  });
};

export default initLocationPicker;
